const homePagePayload = {
  testimonials: {
    enable: true,
    count: 10,
  },
  blogs: {
    enable: true,
    count: 3,
  },
 
   brands:{
    enable: true,
    count: 10,
  }
};

export default homePagePayload;
